// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608031634/js/" + chunkId + "." + {"44":"71a44c6e","225":"87755727","481":"53349889","486":"c1c76301","770":"ba797a97"}[chunkId] + ".0.31557933887747525.chunk.js";
};